import React from 'react'

import {
  useAPIDocumentCollectionCategoriesList,
  type ResponseSuccessGetDocumentCategoryList,
} from 'api/document_collection/useAPIDocumentCollection'

const useCategories = () => {
  const [lastPageNumber, setLastPageNumber] = React.useState<number>(0)
  const { data, ...rest } = useAPIDocumentCollectionCategoriesList({
    limit: 10,
  })

  const categoriesData = React.useMemo(() => {
    if (rest.isLoading) return []
    return data?.pages.flatMap((page) => page.data) ?? []
  }, [data?.pages, rest.isLoading])

  const categoriesMeta = React.useMemo(() => {
    if (rest.isLoading)
      return {} as ResponseSuccessGetDocumentCategoryList['meta']
    return data?.pages?.[(data?.pages ?? []).length - 1]?.meta
  }, [data?.pages, rest.isLoading])

  const hasCategoriesData = React.useMemo(
    () => Object.keys(categoriesData).length > 0,
    [categoriesData]
  )

  const categoriesCount = React.useMemo(
    () => data?.pages?.[0]?.meta?.total ?? 0,
    [data?.pages]
  )

  React.useEffect(() => {
    if (!categoriesMeta?.isNextPageError) {
      const { offset, limit } = categoriesMeta
      const currentPageNumber = offset / limit + 1
      setLastPageNumber(currentPageNumber)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoriesMeta])

  return {
    ...rest,
    hasCategoriesData,
    categoriesData,
    categoriesCount,
    categoriesMeta,
    lastPageNumber,
  }
}

export default useCategories
